import React from "react";
import SmartLink from "../../../../elements/smart-link/smart-link";
import MobileMenuWrapper from "../MobileMenuWrapper";
import { ImageLayout } from "../../../../elements/image/ImageLayout";
import { Box } from "@mui/material";
import { StyledButton, StyledSwipeableDrawer, StyledTypography } from "../../../../../styled-mui";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router";
import AsyncCall from "../../../../../_foundation/gtm/async.service";
import storeUtil from "../../../../../utils/storeUtil";
import { M_PRIME_ADAPT, M_PRIME_RENOV } from "../../../../../constants/routes";

interface Props {
  open: boolean;
  entireMenuCloseHandler: () => any;
  closeCurrentMenu: () => any;
  menuLinksData: Record<string, any>;
}

const lesAidesData = [
  {
    id: 1,
    img: "/images/header/maprimerenov.png",
    title: "MaPrimeAdapt’",
    desc: "Adaptation du logement aux seniors et PMR",
    link: M_PRIME_ADAPT,
  },
  {
    id: 2,
    img: "/images/header/maprimeadapt.png",
    title: "MaPrimeRenov’",
    desc: "Rénovation énergétique de votre habitation",
    link: M_PRIME_RENOV,
  },
];

const MobilePostEtServicesMenu: React.FC<Props> = ({
  open,
  entireMenuCloseHandler,
  closeCurrentMenu,
  menuLinksData,
}) => {
  const serviceData = menuLinksData?.services;
  const navigate = useNavigate();

  const onLinkClick = (item: Record<string, any>) => {
    AsyncCall.sendPageClickCtaEvent({ btn_label: item?.label || "" });
    entireMenuCloseHandler();
  };

  const onButtonClick = () => {
    entireMenuCloseHandler();
    navigate(serviceData?.url);
  };

  return (
    <StyledSwipeableDrawer
      anchor="left"
      open={open}
      onClose={closeCurrentMenu}
      onOpen={() => null}
      className="header-menu-level2 mobile-pose-menu">
      <MobileMenuWrapper
        title="Pose et services"
        isASubMenu
        entireMenuCloseHandler={entireMenuCloseHandler}
        closeCurrentMenu={closeCurrentMenu}>
        {serviceData?.list?.map((item: Record<string, any>, index: number) => (
          <SmartLink
            key={item?.label + index}
            to={item?.link || ""}
            onClick={() => onLinkClick(item)}
            styles={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "16px 12px",
              borderBottom: "1px solid rgba(0, 0, 0, 0.11)",
            }}>
            {item?.icon && (
              <ImageLayout
                src={storeUtil.getUrlPicture(`${item.icon}`, "")}
                height={24}
                width={24}
                styles={{ margin: "unset" }}
              />
            )}
            <StyledTypography
              variant="body1"
              component="p"
              style={{ fontSize: "15px", fontWeight: "600", lineHeight: "20px" }}>
              {item?.label}
            </StyledTypography>
          </SmartLink>
        ))}
        <Box padding={3}>
          <StyledButton
            variant="text"
            onClick={onButtonClick}
            sx={{
              display: "flex",
              alignItems: "center",
              columnGap: "8px",
              fontSize: "15px",
              fontWeight: "500",
              lineHeight: "15px",
              textTransform: "none",
              color: "rgba(93, 137, 162, 1)",
              marginBottom: "35px",
            }}>
            Voir tous nos services
            <ArrowForwardIcon sx={{ width: 20 }} />
          </StyledButton>
          <Box className="les-aides">
            <StyledTypography
              variant="h5"
              component="h5"
              style={{
                fontSize: "16px",
                lineHeight: "20px",
                color: "rgba(132, 132, 132, 1)",
                textTransform: "none",
                marginBottom: "15px",
              }}>
              Les aides
            </StyledTypography>
            {lesAidesData.map((aideData: Record<string, any>, index: number) => (
              <SmartLink
                className="les-aide-mobile-card"
                key={aideData?.id}
                to={aideData?.link}
                onClick={() => entireMenuCloseHandler && entireMenuCloseHandler()}
                styles={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "15px",
                  backgroundColor: "rgba(239, 243, 246, 1)",
                  borderRadius: "8px",
                  marginBottom: "8px",
                  padding: "8px",
                }}>
                <ImageLayout
                  src={aideData?.img}
                  alt={aideData?.title}
                  width={80}
                  height={80}
                  styles={{ margin: "unset" }}
                />
                <Box padding={2}>
                  <StyledTypography
                    variant="h5"
                    className="les-aide-title"
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      lineHeight: "20px",
                      color: "#212121",
                      textTransform: "none",
                    }}>
                    {aideData?.title}
                  </StyledTypography>
                  <StyledTypography
                    variant="subtitle2"
                    component="p"
                    className="les-aide-desc"
                    style={{
                      fontSize: "13px",
                      fontWeight: "500",
                      lineHeight: "20px",
                      marginTop: "4px",
                      color: "rgba(66, 66, 66, 1)",
                    }}>
                    {aideData?.desc}
                  </StyledTypography>
                </Box>
              </SmartLink>
            ))}
          </Box>
        </Box>
      </MobileMenuWrapper>
    </StyledSwipeableDrawer>
  );
};

export default MobilePostEtServicesMenu;
